import React, { useState, useEffect } from 'react';
import axios from 'axios';

function FeaturedCategories() {
    const [categories, setCategories] = useState([]);
    const [featuredIds, setFeaturedIds] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCategories();
        fetchFeatured();
    }, []);

    const fetchCategories = async () => {
        try {
            const tg = window.Telegram.WebApp;
            const res = await axios.get('/api/merchant/custom-categories', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setCategories(res.data);
        } catch (error) {
            console.error('获取分类失败', error);
        }
    };

    const fetchFeatured = async () => {
        try {
            const tg = window.Telegram.WebApp;
            const res = await axios.get('/api/merchant/featured-categories', {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setFeaturedIds(res.data.data.map(item => item.custom_category_id));
        } catch (error) {
            console.error('获取置顶分类失败', error);
        }
    };

    const toggleFeatured = async (categoryId) => {
        let newFeatured = [...featuredIds];
        
        if (newFeatured.includes(categoryId)) {
            newFeatured = newFeatured.filter(id => id !== categoryId);
        } else {
            if (newFeatured.length >= 3) {
                alert('最多只能选择3个置顶分类');
                return;
            }
            newFeatured.push(categoryId);
        }
        
        setLoading(true);
        try {
            const tg = window.Telegram.WebApp;
            await axios.put('/api/merchant/featured-categories', 
                { categoryIds: newFeatured },
                { headers: { 'x-telegram-init-data': tg.initData } }
            );
            setFeaturedIds(newFeatured);
            alert('置顶分类更新成功');
        } catch (error) {
            alert('更新失败：' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2>置顶分类管理</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
                选择最多3个分类置顶，置顶的分类会显示在顾客点餐页面的左侧栏顶部
            </p>
            
            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
                <h3>选择置顶分类</h3>
                <p style={{ fontSize: '14px', color: '#ff6b6b', marginBottom: '15px' }}>
                    已选择 {featuredIds.length}/3 个置顶分类
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {categories.length === 0 ? (
                        <p style={{ color: '#999' }}>暂无分类，请先在菜品分类中添加</p>
                    ) : (
                        categories.map(cat => (
                            <div 
                                key={cat.id} 
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '12px',
                                    background: 'white',
                                    borderRadius: '8px',
                                    border: featuredIds.includes(cat.id) ? '1px solid #ff6b6b' : '1px solid #eee'
                                }}
                            >
                                <span style={{ fontSize: '15px' }}>{cat.name}</span>
                                <button
                                    onClick={() => toggleFeatured(cat.id)}
                                    disabled={loading}
                                    style={{
                                        padding: '6px 16px',
                                        background: featuredIds.includes(cat.id) ? '#ff6b6b' : '#f0f0f0',
                                        color: featuredIds.includes(cat.id) ? 'white' : '#666',
                                        border: 'none',
                                        borderRadius: '20px',
                                        cursor: 'pointer',
                                        fontSize: '13px'
                                    }}
                                >
                                    {featuredIds.includes(cat.id) ? '⭐ 已置顶' : '☆ 设为置顶'}
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

export default FeaturedCategories;